import { ReactNode } from "react";
import "./house.css";
import HouseMehrfamilienhaus from "./houses/mehrfamilienhaus";
import { useStore } from "../state/state";
import HouseEinfamilienhaus from "./houses/einfamilienhaus.tsx";
import HouseReihenMittelhaus from "./houses/reihenmittelhaus.tsx";
import HouseReihenEckhaus from "./houses/reiheneckhaus.tsx";
import HouseMehrfamilienMittelhaus from "./houses/mehrfamilienmittelhaus.tsx";
import HouseMehrfamilienEckhaus from "./houses/mehrfamilieneckhaus.tsx";
import { MENU_ITEMS } from "../state/types.ts";
import Bubbles from "./statistic/bubbles.tsx";

export default function House(props:{dialogs: Record<string, ReactNode>}) {
  const push_modal = useStore((state) => state.push_modal_closeable);
  const selected_menu_item = useStore((state) => state.selected_menu_item) ?? "";
  const gebaeude_typ = useStore((state) => state.gebaeude_typ);

  const set_selected_menu_item = useStore(
    (state) => state.set_selected_menu_item,
  );
  const enter_element = (id: string) => {
    set_selected_menu_item(id);
  };
  const exit_element = () => {
    set_selected_menu_item("");
  };
  const click_element = (id: string) => {
    const item = MENU_ITEMS.find((item) => item.id === id);
    if(item !== undefined){
      push_modal(props.dialogs[item.id]);
      set_selected_menu_item(id);
    }

  };

  const element_styling_function = (id: string) =>
    ({opacity: selected_menu_item == id ? 0.0 : 0.0});

  const icon_styling_function = (id: string) =>
    ({opacity: selected_menu_item == id ? 1.0 : 0.6});

  const outline_styling_function = (id: string) =>
    ({opacity: selected_menu_item == id ? 1.0 : 0.0});

  switch (gebaeude_typ){
    case "sfh":
      return (
        <div className="house" aria-hidden>
          
          <HouseEinfamilienhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
    case "thm":
      return (
        <div className="house" aria-hidden>
          
          <HouseReihenMittelhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
    case "the":
      return (
        <div className="house" aria-hidden>
          
          <HouseReihenEckhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
    case "mfh":
      return (
        <div className="house" aria-hidden>
          
          <HouseMehrfamilienhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
    case "mfm":
      return (
        <div className="house" aria-hidden>
          
          <HouseMehrfamilienMittelhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
    case "mfe":
      return (
        <div className="house" aria-hidden>
          
          <HouseMehrfamilienEckhaus
            selected_menu_item={selected_menu_item}
            onEnterElement={enter_element}
            onLeaveElement={exit_element}
            onClickElement={click_element}
            element_styling_function={element_styling_function}
            icon_styling_function={icon_styling_function}
            outline_styling_function={outline_styling_function}
          />
        </div>
      );
  }

}


// .house svg :is(#dach-2, #photovoltaik-2, #fenster-2, #fassade-2, #heizung-2) g:first-of-type > :is(path){
//     fill:var(--house-icons);
// }


// .house svg :is(#solarthermie-2) :is(path):first-of-type{
//     fill:var(--house-icons);
// }
